import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ContentChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeInputWrapperComponent, InputSize } from "../ape-input-wrapper/ape-input-wrapper.component";
import { MultiSelectModule } from "primeng/multiselect";
import { FormsModule } from "@angular/forms";
import { MenuItem } from "primeng/api";
import { UserMenuItem } from "src/app/constants/utils-type";

export type MultiSelectVariant = "filled" | "outlined";

@Component({
  selector: "ape-multi-select",
  standalone: true,
  templateUrl: "./ape-multi-select.component.html",
  styleUrls: ["./ape-multi-select.component.css"],
  imports: [
    CommonModule,
    ApeInputWrapperComponent,
    MultiSelectModule,
    FormsModule
  ]
})
export class ApeMultiSelectComponent extends ApeInputWrapperComponent implements OnInit {
  /**
   * Dimensione del multi-select
   */
  @Input() override size?: InputSize = "medium";

  /**
   * Placeholder del multi-select
   */
  @Input() placeholder?: string = "";

  /**
   * ID univoco del componente
   */
  @Input() id!: string;

  /**
   * Opzioni selezionate
   */
  @Input() selectedOptions?: MenuItem[] | UserMenuItem[] = [];

  /**
   * Lista delle opzioni disponibili
   */
  @Input() options?: MenuItem[] | UserMenuItem[] = [];

  /**
   * Proprietà dell'oggetto da usare come label
   */
  @Input() optionLabel?: string = "label";

  /**
   * Proprietà dell'oggetto da usare come chiave univoca per il confronto degli oggetti
   * Permette a PrimeNG di confrontare gli oggetti per valore invece che per riferimento
   */
  @Input() dataKey?: string = "id";

  /**
   * Variante del multi-select (filled o outlined)
   */
  @Input() variant: MultiSelectVariant = "outlined";

  /**
   * Se mostrare un pulsante per cancellare la selezione
   */
  @Input() showClear: boolean = false;

  /**
   * Se il multi-select è filtrabile
   */
  @Input() filter: boolean = false;

  /**
   * Titolo del tooltip per l'icona info
   */
  @Input() override infoIconTitle?: string;

  /**
   * Massimo numero di etichette selezionate da mostrare
   */
  @Input() maxSelectedLabels?: number = 3;

  /**
   * Testo mostrato quando il numero di opzioni selezionate supera maxSelectedLabels
   */
  @Input() selectedItemsLabel?: string = "{0} elementi selezionati";

  /**
   * Numero massimo di opzioni selezionabili
   */
  @Input() selectionLimit?: number | undefined = undefined;

  /**
   * Evento emesso quando cambia la selezione
   */
  @Output() selectedOptionsChange = new EventEmitter<MenuItem[] | UserMenuItem[]>();

  /**
   * Evento emesso quando chiude il panel del multi-select, emette i correnti elementi selezionati
   */
  @Output() onPanelClose = new EventEmitter<MenuItem[] | UserMenuItem[]>();

  /**
   * Template personalizzato per le opzioni del multi-select
   */
  @ContentChild("optionTemplate") optionTemplate?: TemplateRef<unknown>;

  /**
   * Template personalizzato per le opzioni selezionate
   */
  @ContentChild("selectedTemplate") selectedTemplate?: TemplateRef<unknown>;

  /**
   * Template personalizzato per l'header del multi-select
   */
  @ContentChild("headerTemplate") headerTemplate?: TemplateRef<unknown>;

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Genera l'id se non è stato fornito come input
    if (!this.id) {
      this.id = "multi-select-" + Math.random()
        .toString(36)
        .substring(2, 15);
    }
  }

  /**
   * Gestisce il cambio di selezione
   * @param event - Evento di cambio selezione
   */
  onSelectionChange(event: MenuItem[] | UserMenuItem[]): void {
    this.selectedOptions = event;
    this.selectedOptionsChange.emit(event);
  }

  onPanelClosed(): void {
    this.onPanelClose.emit(this.selectedOptions);
  }

  trackByFn(index: number): number {
    return index;
  }
}
